import { memo } from 'react';

const Banner = () => {
  return (
    <div className={'w-full bg-[#D4E7FF] h-[250px]'}>
      <div className={'max-w-[1920px]  min-w-[1440px] m-auto h-[250px]'}>
        <img
          src="//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-banner-5.png"
          alt="品牌banner"
          className={'h-[100%] w-[100%]'}
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
    </div>
  );
};

export default memo(Banner);
